module.exports = __webpack_public_path__ + "img/08.81df63f2.png";